import { render, staticRenderFns } from "./IconBetaDashboard.vue?vue&type=template&id=28f6c896&"
import script from "./IconBetaDashboard.vue?vue&type=script&lang=ts&"
export * from "./IconBetaDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports